import type { Min } from '@trackback/widgets';
import { createSimpleNamedExpressionResolver } from '../types';

export const minResolver = createSimpleNamedExpressionResolver<Min>(
  'min',
  nums => nums.reduce((p, c) => (isNaN(p) || c < p ? c : p), NaN)
);
